import { Box } from "@material-ui/core";
import { useRef, useState } from "react";

import { useSelector } from "react-redux";
import { getCurrentStep } from "../../redux/selector";
import EditButton from "../EditButton/EditButton";
import "./FormBox.scss";

function FormBox({
    MandatoryRequired = false,
    header,
    header2,
    redirectTo,
    children,
    style,
    tooltip,
    header3,
    showAlways = false,
    isMaxWidth = true,
}) {
    const [mouseOn, setMouseOn] = useState(false);
    const currentStep = useSelector(getCurrentStep());
    const childRef = useRef(null);
    return (
        <Box
            className="formWrapper"
            style={style}
            onMouseEnter={() => {
                setMouseOn(true);
            }}
            onMouseLeave={() => {
                setMouseOn(false);
            }}
        >
            {header && (
                <Box className="formHeader" sx={{ display: "flex" }}>
                    <Box className={redirectTo && isMaxWidth ? "maxWith" : ""}>
                        {header}
                        {MandatoryRequired && <Box component="span" className="danger">
                            *
                        </Box>}
                        {tooltip}
                        {header3 && header3}
                    </Box>
                    {redirectTo && currentStep !== "Approval" && (
                        <Box
                            sx={{ ml: 4 }}
                            tabIndex="0"
                            onFocus={(e) => {
                                setMouseOn(true);
                                // childRef.current.setOpenPopup();
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    childRef.current.setOpenPopup(true);
                                }
                            }}
                            onBlur={() => {
                                setMouseOn(false);
                            }}
                        >
                            <EditButton
                                cRef={childRef}
                                redirectTo={redirectTo}
                                buttonOn={mouseOn || showAlways}
                            />
                        </Box>
                    )}
                </Box>
            )}
            {header2 && <Box className="formHeader danger bold">{header2}</Box>}

            {children}
        </Box>
    );
}

export default FormBox;
